import { ReportSummaryAction } from '../actions/reportSummary'

const initialState: Props = {
  clientId: 0,
  tableColumns: [],
  tableData: [],
  totalClickReport: 0,
  sum: 0,
  isFetching: false,
  fetchError: '',
}

interface Props {
  clientId: number
  tableColumns: any
  tableData: any
  totalClickReport: number
  sum: number
  isFetching: boolean
  fetchError: string
}

const reducer = (
  state: Props = initialState,
  action: ReportSummaryAction,
): Props => {
  switch (action.type) {
    case 'INIT_REPORT_SUMMARY': {
      // 画面を開き直したときに前回のエラーが残らないようクリアする
      return {
        ...state,
        clientId: action.clientId,
        fetchError: '',
      }
    }
    case 'REQUEST_FETCH_REPORT_SUMMARY': {
      return {
        ...state,
        isFetching: true,
        fetchError: '',
      }
    }
    case 'COMPLETE_FETCH_REPORT_SUMMARY': {
      return {
        ...state,
        tableColumns: action.report.data_columns,
        tableData: action.report.data,
        sum: action.report.sum,
        isFetching: false,
      }
    }
    case 'FAIL_FETCH_REPORT_SUMMARY': {
      return {
        ...state,
        isFetching: false,
        fetchError: action.error,
      }
    }
    case 'COMPLETE_GET_TOTAL_CLICK_REPORT': {
      return {
        ...state,
        totalClickReport: action.report,
      }
    }
    case 'CLEAR_TABLE_STATE': {
      return {
        ...state,
        tableColumns: [],
        tableData: [],
        fetchError: '',
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
